import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Command Line",
description: "Learn how to use and customize the generated command-line application in Freon, including adding and initializing your own actions.",
tags: [ "command line", "customization", "FreonCommandLineRunner", "DSL development", "actions", "CLI"] ,
modifiedTime: "2025-11-07T17:20:18.626Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};